import "@fontsource-variable/inter"
import "@/styles/app.css"
import React from "react"
import ReactDOM from "react-dom/client"
import { RouterProvider } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Toaster, toast } from "sonner"
import { ThemeProvider } from "@/providers/theme-provider"
import { AuthProvider } from "@/providers/auth-provider"
import { router } from "@/router"
import { ApiClientError } from "@/lib/api-client"
import "@/lib/i18n"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Don't retry on 401/403/404 — these won't resolve on retry
        if (error instanceof ApiClientError && [401, 403, 404].includes(error.status)) {
          return false
        }
        return failureCount < 1
      },
    },
    mutations: {
      onError: (error) => {
        if (error instanceof ApiClientError) {
          if (error.status === 403) {
            toast.error("Brak uprawnień do wykonania tej operacji")
          } else if (error.status === 401) {
            toast.error("Sesja wygasła — zaloguj się ponownie")
            window.location.href = "/login"
          } else {
            toast.error(error.message)
          }
        }
      },
    },
  },
})

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster
            position="bottom-right"
            toastOptions={{
              className: "!rounded-lg !shadow-md !bg-[var(--bg-surface)] !border !border-border !text-[var(--text-primary)] !text-[13px]",
            }}
          />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
